import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { EntityNameSearchView } from './advanced-search';
import { SearchRepositoryService } from './search.repository';

export function searchDowngrader(app: any) {
   app.factory(SearchRepositoryService.injectName, downgradeInjectable(SearchRepositoryService));
   app.directive('amSearchEntityName', downgradeComponent({
      component: EntityNameSearchView
   }));
}